import { render, staticRenderFns } from "./fenxiao_withdraw_apply.vue?vue&type=template&id=b2b3c064&scoped=true"
import script from "./fenxiao_withdraw_apply.vue?vue&type=script&lang=js"
export * from "./fenxiao_withdraw_apply.vue?vue&type=script&lang=js"
import style0 from "./fenxiao_withdraw_apply.vue?vue&type=style&index=0&id=b2b3c064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b3c064",
  null
  
)

export default component.exports